import { render, staticRenderFns } from "./TeaserTextLayer.vue?vue&type=template&id=6e9918f9&functional=true&"
import script from "./TeaserTextLayer.vue?vue&type=script&lang=ts&"
export * from "./TeaserTextLayer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports